import { Link, useParams } from 'react-router-dom';
import SEO from '../components/SEO';
import { FAQ_ARTICLES } from '../data/faqArticles';

export default function FaqArticlePage() {
  const { slug } = useParams();
  const article = FAQ_ARTICLES.find((item) => item.slug === slug);

  if (!article) {
    return <section className="space-y-3"><h1 className="text-2xl font-bold">FAQ not found</h1><Link to="/faq" className="text-brand-accent underline">Back to FAQ index</Link></section>;
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{ '@type': 'Question', name: article.title, acceptedAnswer: { '@type': 'Answer', text: article.summary } }]
  };

  return (
    <>
      <SEO title={`${article.title} | GradeVIT`} description={article.summary} keywords="VIT GPA FAQ, VIT CGPA FAQ" canonicalPath={`/faq/${article.slug}`} />
      <article className="elevated space-y-4 rounded-2xl border border-brand-border bg-brand-surface p-6">
        <h1 className="text-2xl font-bold">{article.title}</h1>
        <p className="text-brand-muted">{article.summary}</p>
        {article.content.map((paragraph) => <p key={paragraph} className="text-sm leading-6 text-brand-text">{paragraph}</p>)}
        <Link to="/faq" className="inline-block text-sm font-semibold text-brand-accent underline">Back to all FAQs</Link>
      </article>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </>
  );
}
